import { configureStore } from "@reduxjs/toolkit";
import UserSlice from "../slices/UserSlice";
import notificationSlices from "../slices/NotificationSlice";
import UserControlSlices from "../slices/UserControlSlice";

export const store = configureStore({
    reducer: {
        user: UserSlice,
        notification: notificationSlices,
        userControl: UserControlSlices
    }
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch